import type { ReactElement } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FontWeight, getFontFamily } from "@/theme/typography";
import { getRadiusCssValue } from "@/theme/radius";
import { pxToRem } from "@/theme/spacing";
import { CmarkdownLabelText } from "../Cmarkdowntext/CmarkdownLabelText";
import { toTitleCase, type MetadataEntry } from "./kanban-selectors";
import { METADATA_TOOLTIP_BACKGROUND, METADATA_TOOLTIP_BORDER, } from "./kanban-view-constants";
interface KanbanCardTooltipProps {
    cardKey: string;
    isHovered: boolean;
    metadataEntries: MetadataEntry[];
}
export function KanbanCardTooltip({ cardKey, isHovered, metadataEntries, }: KanbanCardTooltipProps): ReactElement {
    return (<AnimatePresence>
      {isHovered && metadataEntries.length > 0 ? (
        <motion.div initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 4 }} transition={{
                duration: 0.16,
                ease: "easeOut",
            }} style={{
                position: "absolute",
                left: "50%",
                bottom: `calc(100% + ${pxToRem(10)})`,
                transform: "translateX(-50%)",
                width: "max-content",
                maxWidth: pxToRem(220),
                padding: `${pxToRem(7)} ${pxToRem(9)}`,
                borderRadius: getRadiusCssValue(8),
                backgroundColor: METADATA_TOOLTIP_BACKGROUND,
                border: METADATA_TOOLTIP_BORDER,
                boxShadow: "0 14px 24px -16px rgba(0, 0, 0, 0.95)",
                zIndex: 2,
                pointerEvents: "none",
            }}>
            {metadataEntries.map((entry) => (<div key={`${cardKey}-tooltip-${entry.key}`} style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: pxToRem(6),
                }}>
                <span style={{
                    color: "rgba(255, 255, 255, 0.48)",
                    fontSize: pxToRem(11),
                    fontFamily: getFontFamily(),
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                }}>
                  {`${toTitleCase(entry.key)}:`}
                </span>
                <CmarkdownLabelText dataElScope="Cmarkdownkanban/KanbanCardTooltip" content={entry.value} size={11} weight={FontWeight.Medium} paragraphStyle={{ marginBottom: 0 }} textStyle={{
                    color: "rgba(255, 255, 255, 0.82)",
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                }}/>
              </div>))}
          </motion.div>
        ) : null}
    </AnimatePresence>);
}
